import ActivateCouponError from './ActivateCouponError';
class ActivateCouponPropertyNotFound extends ActivateCouponError {
    propertyId;
    constructor(propertyId, options) {
        super('The crowdfunding property does not exist', options);
        this.propertyId = propertyId;
    }
}
export default ActivateCouponPropertyNotFound;
